import { useSearch, useNavigate } from "@tanstack/react-router";
import { useMemo } from "react";

import { baseURL } from "../utils";

export interface Filter {
  pageNumber: number;
  pageSize: number;
  orderBy: string;
  order: "asc" | "desc";
  [key: string]: string | number | boolean | undefined;
}

export const defaultFilters: Filter = {
  pageNumber: 1,
  pageSize: 10,
  orderBy: "createdAt",
  order: "desc",
};

export const useFilters = (defaults?: Partial<Filter>) => {
  const search = useSearch({ strict: false }) as Filter;
  const navigate = useNavigate();

  const filters = useMemo(
    () => ({
      ...defaultFilters,
      ...defaults,
      ...search, // router query takes priority
    }),
    [search, defaults],
  );

  const setFilters = (newFilters: Partial<Filter>) => {
    navigate({
      search: (prev: Filter) => ({
        ...prev,
        ...newFilters,
      }),
    });
  };

  const buildApiUrl = (resourcePath: string) => {
    const url = new URL(resourcePath, baseURL);

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined) url.searchParams.append(key, String(value));
    });

    return url.href;
  };

  return { filters, setFilters, buildApiUrl };
};
